//https://stackoverflow.com/questions/60911209/how-to-detect-the-window-width-change

import { useCallback, useEffect, useState } from "react";

export interface MediaObj {
  isSmall: boolean;
  isMedium: boolean;
  isLarge: boolean;
  isExtraLarge: boolean;
}

//upper limit (BP) for each device. based off Bootstrap breakpoints
const mobileBP = 768; //sm
const tabletBP = 992; //md
const laptopBP = 1200; //lg
const dekstopBP = 1400; //xlg

const defaultValues = {
  isSmall: window.innerWidth <= mobileBP ? true : false,
  isMedium:
    window.innerWidth > mobileBP && window.innerWidth <= tabletBP
      ? true
      : false,
  isLarge:
    window.innerWidth > tabletBP && window.innerWidth <= laptopBP
      ? true
      : false,
  isExtraLarge: window.innerWidth > laptopBP ? true : false,
};

let previousBreakpoints = defaultValues;

const useDetectScreenBreakpoints = () => {
  const [mediaType, setMediaType] = useState<MediaObj>(defaultValues);
  let timeout = false;

  //register callback so our function isn't instantiated on each re-render.
  const handleWindowResize = useCallback((timeout: any) => {
    // clear the timeout
    clearTimeout(timeout);
    // debounce getDimensions function ever N ms
    timeout = setTimeout(getDimensions, 1000);

    //store width/height and mediaState
    function getDimensions() {
      let width = window.innerWidth;
      let height = window.innerHeight;
      //console.log("Width Saved!: ", width);

      let newBreakPoints = {
        isSmall: window.innerWidth <= mobileBP ? true : false,
        isMedium:
          window.innerWidth > mobileBP && window.innerWidth <= tabletBP
            ? true
            : false,
        isLarge:
          window.innerWidth > tabletBP && window.innerWidth <= laptopBP
            ? true
            : false,
        isExtraLarge: window.innerWidth > laptopBP ? true : false,
      };

      /*
      console.log("previousBreakpoints state:");
      console.log("previousBreakpoints isSmall:" + previousBreakpoints.isSmall);
      console.log(
        "previousBreakpoints isMedium:" + previousBreakpoints.isMedium
      );
      console.log("previousBreakpoints isLarge:" + previousBreakpoints.isLarge);
      console.log(
        "previousBreakpoints isExtraLarge:" + previousBreakpoints.isExtraLarge
      );

      
      console.log("newBreakPoints isSmall:" + newBreakPoints.isSmall);
      console.log("newBreakPoints isMedium:" + newBreakPoints.isMedium);
      console.log("newBreakPoints isLarge:" + newBreakPoints.isLarge);
      console.log("newBreakPoints isExtraLarge:" + newBreakPoints.isExtraLarge);
      */

      let screenBreakPointsChanged =
        previousBreakpoints.isSmall != newBreakPoints.isSmall ||
        previousBreakpoints.isMedium != newBreakPoints.isMedium ||
        previousBreakpoints.isLarge != newBreakPoints.isLarge ||
        previousBreakpoints.isExtraLarge != newBreakPoints.isExtraLarge;

      //console.log("breakPoints changed:" + screenBreakPointsChanged);

      if (screenBreakPointsChanged) {
        previousBreakpoints.isSmall = newBreakPoints.isSmall;
        previousBreakpoints.isMedium = newBreakPoints.isMedium;
        previousBreakpoints.isLarge = newBreakPoints.isLarge;
        previousBreakpoints.isExtraLarge = newBreakPoints.isExtraLarge;
        setMediaType(newBreakPoints);
      }
    }
  }, []);

  useEffect(() => {
    // window.resize event listener will call handleWindowResize() whenever screen width is adjusted.
    window.addEventListener("resize", handleWindowResize);

    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  return {
    isSmall: mediaType.isSmall,
    isMedium: mediaType.isMedium,
    isLarge: mediaType.isLarge,
    isExtraLarge: mediaType.isExtraLarge,
  };
};

export default useDetectScreenBreakpoints;
